var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 25.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43,16C43,9,35.81,3.28,27,3.28S11,9,11,16s7.18,12.72,16,12.72a18.83,18.83,0,0,0,9.42-2.44l5.24,2.24-1.51-5.29A10.93,10.93,0,0,0,43,16ZM27,26.73c-7.73,0-14-4.81-14-10.73S19.26,5.27,27,5.27,41,10.08,41,16a9.09,9.09,0,0,1-2.69,6.29l-.23.24-2,1.61-.29.18A16.69,16.69,0,0,1,27,26.73Z",
    transform: "translate(-10.99 -3.28)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.84,
    y: 7.98,
    width: 14.32,
    height: 1.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.84,
    y: 7.98,
    width: 14.32,
    height: 1.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.84,
    y: 11.85,
    width: 14.32,
    height: 1.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.84,
    y: 15.66,
    width: 14.32,
    height: 1.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChat);
export default __webpack_public_path__ + "static/media/menu-chat.4a87e511.svg";
export { ForwardRef as ReactComponent };